/**
 * `applicationServerKey` wants raw bytes, but the API hands the VAPID public key over as a
 * base64url string. This is the conversion, and it is the single likeliest place in the whole
 * push flow for a silent bug: get the `-`/`_` swap or the padding wrong and `subscribe()`
 * rejects with an opaque `InvalidCharacterError` that names nothing.
 */
export function urlBase64ToUint8Array(base64UrlString: string): Uint8Array<ArrayBuffer> {
  const padding = "=".repeat((4 - (base64UrlString.length % 4)) % 4);
  const base64 = (base64UrlString + padding).replace(/-/g, "+").replace(/_/g, "/");

  const raw = window.atob(base64);
  // Backed by a plain ArrayBuffer on purpose: `applicationServerKey` takes a BufferSource, and
  // the default `Uint8Array<ArrayBufferLike>` does not satisfy it (it could be shared memory).
  const bytes = new Uint8Array(new ArrayBuffer(raw.length));
  for (let i = 0; i < raw.length; i += 1) {
    bytes[i] = raw.charCodeAt(i);
  }
  return bytes;
}
